import React from "react";
import LegalPage from "components/Legal/LegalPage.jsx";

export default function KiHinweisPage() {
    return (
        <LegalPage title="KI-Hinweis">
            <p>
                kimat-online verwendet automatisierte und KI-gestützte Verfahren zur
                Analyse von Nachrichteninhalten und zur Erzeugung allgemeiner Signale,
                Klassifizierungen oder Einschätzungen.
            </p>

            <h2>Funktionsweise</h2>
            <ul>
                <li>Nachrichteninhalte werden automatisiert ausgewertet.</li>
                <li>Texte können nach Stimmung, Relevanz oder Tendenz klassifiziert werden.</li>
                <li>Ergebnisse können ohne menschliche Einzelfallprüfung angezeigt werden.</li>
            </ul>

            <h2>Grenzen der KI</h2>
            <ul>
                <li>KI-Systeme können Fehler machen.</li>
                <li>Ergebnisse können unvollständig oder missverständlich sein.</li>
                <li>Marktauswirkungen von Nachrichten sind nicht eindeutig vorhersagbar.</li>
                <li>Es besteht keine Garantie auf inhaltliche oder wirtschaftliche Richtigkeit.</li>
            </ul>

            <h2>Keine individuelle Empfehlung</h2>
            <p>
                Die KI berücksichtigt keine persönlichen Vermögensverhältnisse, keine
                individuelle Risikoneigung und keine persönlichen Anlageziele.
            </p>
        </LegalPage>
    );
}